import React from 'react'

import Checkbox from '@SonarCX/pages/Settings/Controls/Checkbox'

import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'
import useStyles from './styles'

const SubtaskCheckbox: React.FC = () => {
  const { includeSubtasks, setIncludeSubtasks } = useTaskFilters()

  const classes = useStyles()

  return (
    <Checkbox
      checked={includeSubtasks}
      onCheck={setIncludeSubtasks}
      className={classes.root}
    >
      Subtasks
    </Checkbox>
  )
}

export default SubtaskCheckbox
